<template>
  <ListView
    title="Clinic Profiles"
    :isFluid="true"
    @reload="reload"
    @create="actionCreate"
    @navDetails="actionDetails"
    :enable-create="isAdmin"
    :search.sync="search"
    :data="data"
    :page.sync="page"
    :header="header"
    :sort.sync="sort"
    :search-box-placeholder="placeholder"
  >
    <template v-slot:filter>
      <div class="d-flex align-center mb-8 flex-gap">
        <fletrix-select
          v-model="selectedArea"
          :items="areaOptions"
          hide-details="auto"
          label="Area"
          solo
          style="width: 20rem"
        >
        </fletrix-select>
        <fletrix-select
          v-model="selectedMembership"
          :items="membershipStatuses"
          hide-details="auto"
          label="Membership"
          solo
          style="width: 15rem"
        >
        </fletrix-select>
      </div>
    </template>
    <template v-slot:card="{ cardContent }">
      <ClinicProfileCard
        :content="cardContent"
        class="clickable"
        @click.native="actionDetails(cardContent)"
      />
    </template>

    <template v-slot:item.name_en="{ item }">
      <VipIcon :membership="item.membership" class="mr-1" />
      {{ item.name | parseAndLocalize('en') }}
    </template>

    <template v-slot:item.name_zh_hk="{ item }">
      <VipIcon :membership="item.membership" class="mr-1" />
      {{ item.name | parseAndLocalize('zh-hk') }}
    </template>

    <template v-slot:item.name_zh_cn="{ item }">
      <VipIcon :membership="item.membership" class="mr-1" />
      {{ item.name | parseAndLocalize('zh-cn') }}
    </template>
    <template v-slot:item.staffCount="{ item }">
      {{ item.staffCount || 0 }}
    </template>

    <template v-slot:item.bookingCount="{ item }">
      {{ item.bookingCount || 0 }}
    </template>

    <template v-slot:item.staffProfiles="{ item }">
      <div>
        <div v-for="profile in item.staffProfiles" :key="profile._id">
          {{ profile.phone }} ({{ profile.enabled ? 'Active' : 'Disabled' }})
        </div>
      </div>
    </template>
  </ListView>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import ClinicProfileCard from '@/components/ClinicProfile/ClinicProfileCard';
import VipIcon from '@/components/VipIcon';
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { ProfileStatus } from '@/api/auth/membership';
import { membershipOptions, DistrictsOptions } from '@/data/optionsConstants';
import { FletrixSelect } from '@/components/Atom';

export default {
  name: 'ClinicProfiles',
  mixins: [listViewPageMixin],
  components: { ClinicProfileCard, VipIcon, FletrixSelect },
  data() {
    return {
      ProfileStatus,
      selectedMembership: null,
      selectedArea: null,
      header: [
        { text: 'Clinic (EN)', value: 'name_en', width: '200px', sortable: false },
        { text: 'Clinic (ZH-HK)', value: 'name_zh_hk', width: '200px', sortable: false },
        // { text: 'Clinic (ZH-CN)', value: 'name_zh_cn', width: '200px', sortable: false },

        { text: 'No. of Account', value: 'staffCount', width: '120px', sortable: false },
        { text: 'Account No.', value: 'staffProfiles', width: '120px', sortable: false },
        { text: 'No. of Booking Today', value: 'bookingCount', width: '150px' },
      ],
      populate: [{ path: 'serviceProducts' }],
      sort: { created_at: -1 },
      placeholder: 'Search by Clinic Name/ Phone No.',
    };
  },
  computed: {
    ...mapGetters('auth', ['role', 'isAdmin']),
    restfulURL() {
      return RESTFUL.clinicProfile.list;
    },
    title() {
      return 'Clinic Profiles';
    },
    filter() {
      return {
        membership: this.selectedMembership ? this.selectedMembership : undefined,
        area: this.selectedArea ? this.selectedArea : undefined,
      };
    },
    membershipStatuses() {
      return [
        { text: 'All', value: null },
        { text: 'Non Member', value: 'default' },
        { text: 'VIP Member', value: 'vip' },
      ];
    },
    areaOptions() {
      return [
        { text: 'All', value: null },
        ...DistrictsOptions.map(district => ({
          text: district.label,
          value: district.value,
        })),
      ];
    },
    mergeParams() {
      return {};
    },
  },
  methods: {
    get,
    formatOpenHours(openHours) {
      if (!openHours || !openHours.length) return 'Not set';

      const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const formatTime = minutes => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
      };

      const summary = openHours
        .slice(0, 2)
        .map(h => `${dayNames[h.isoDayOfWeek - 1]} ${formatTime(h.start)}-${formatTime(h.end)}`)
        .join(', ');

      return openHours.length > 2 ? `${summary}...` : summary;
    },
    actionDetails(x) {
      this.$router.push({
        name: 'clinicProfile',
        params: { id: x._id },
      });
    },
    actionCreate() {
      this.$router.push({ name: 'clinicProfileNew' });
    },
  },
};
</script>

<style scoped lang="scss">
.clickable {
  cursor: pointer;
}
</style>
